export const CHAT_COLLECTION = 'chats';
export const CHAT_API_URL = '/api/chat';
export const CANCEL_CHAT_API_URL = '/api/chat/cancel';
export const REPORT_API_URL = '/api/report';
export const SERVICE_STATUS_API_URL = '/api/service-status';
